
import { GameSymbol } from "./gameSymbol_Class";

export class GamePayTableBuilder
{   

   
    private baseSymbol:Array<GameSymbol>;
    private bonusSymbol:Array<GameSymbol>
    constructor(payTable:any)
    {


       
   
        // console.log(payTable)
        let serverVal=payTable;
        let allNormal=[];
        for (let i = 0; i <serverVal.baseGameCombinationPays.length; i++) {
            allNormal.push(serverVal.baseGameCombinationPays[i]);            
        }

        let allBonus=[];
        for (let i = 0; i <serverVal.bonusGameCombinationPays.length; i++) {
            allBonus.push(serverVal.bonusGameCombinationPays[i]);            
        }

       
        let CopieNormal=[];
        for (let i = 0; i < allNormal.length; i++) {
            if(allNormal[i].combinationLength!=undefined)
            {
                CopieNormal[i]=[allNormal[i].symbol,allNormal[i].combinationType,allNormal[i].combinationLength,allNormal[i].multiplier, allNormal[i].bonusSpins];
              
            }
            else if(allNormal[i].count!=undefined)

            {
                CopieNormal[i]=[allNormal[i].symbol,allNormal[i].combinationType,allNormal[i].count,allNormal[i].multiplier, allNormal[i].bonusSpins];
              
            }
             
        }

         let CopieBonus=[];
        for (let i = 0; i < allBonus.length; i++) {

            if(allBonus[i].combinationLength!=undefined)
            {
                CopieBonus[i]=[allBonus[i].symbol,allBonus[i].combinationType,allBonus[i].combinationLength,allBonus[i].multiplier, allBonus[i].bonusSpins];
            }
            else if(allBonus[i].count!=undefined)

            {
            CopieBonus[i]=[allBonus[i].symbol,allBonus[i].combinationType,allBonus[i].count,allBonus[i].multiplier, allBonus[i].bonusSpins];
            }

        }

    
        let maxIndexNormal=this.getSymbolsLength(CopieNormal);
        let maxIndexBonus=this.getSymbolsLength(CopieBonus);

        // console.log(maxIndexNormal,maxIndexBonus);

        this.baseSymbol=[];

        for (let i = 0; i <maxIndexNormal; i++) {
            this.baseSymbol[i]=new GameSymbol();
            this.baseSymbol[i].setType('NORMAL');
            // this.baseSymbol[i].setSymbol(i);
            
        }

        //create bonus symbols table obj
        this.bonusSymbol=[];
        for (let i = 0; i <maxIndexBonus; i++) {
            this.bonusSymbol[i]=new GameSymbol();
            this.bonusSymbol[i].setType('BONUS');
            
            
        }

        this.copyValToObj(CopieNormal,this.baseSymbol,maxIndexNormal);
        this.copyValToObj(CopieBonus,this.bonusSymbol,maxIndexBonus);
        this.sortInOrderOfSymbol(this.baseSymbol);
        this.sortInOrderOfSymbol(this.baseSymbol);
    }

    private sortInOrderOfSymbol=(arr:Array<GameSymbol>):any=>
    {   
        
        arr.sort(function(a, b) {
            return (a.getSymbol()) - (b.getSymbol());
        });

    }

    private copyValToObj=(source:Array<Array<any>>,dest:Array<GameSymbol>,maxLength:number):void=>
    {
        for (let i = 0; i < source.length; i++) {
            for (let j = 0; j < maxLength; j++) {
                if(source[i][0]==j+1)
                {   
                    // console.log(source[i][0])
                    // this.bonusSymbol[i].setSymbol(i);
                    dest[j].setSymbol(source[i][0]);
                    dest[j].setCombinationType(source[i][1]);
                    dest[j].addToCombinaisonLength(source[i][2]);
                    dest[j].addToMultiplier(source[i][3]);
                    dest[j].setBonus(source[i][4]);
                }            
            }
        }
    }

    private getSymbolsLength(arr:Array<Array<number>>)
    {   //
        let maxIndexNormal=0;
        for (let i = 0; i < arr.length; i++) {
            if(maxIndexNormal<arr[i][0])
            {
                maxIndexNormal=arr[i][0];
            }
            
        }
        return maxIndexNormal;
    }


    public getMultipler(index:number,baseGameSymbol:boolean)
    {   
      
        if(baseGameSymbol){
           
            return this.baseSymbol[index].getMultiplier();
        }
        else
        {   //returns bonus symbol
            return this.bonusSymbol[index].getMultiplier();
        }
  
    }

    public getComLength(index:number,baseGameSymbol:boolean)
    {   
      
        if(baseGameSymbol){
            return this.baseSymbol[index].getCombinaisonLength();
        }
        else
        {   //returns bonus symbol
            return this.bonusSymbol[index].getCombinaisonLength();
        }
    
    }

    public getBonus(index:number,baseGameSymbol:boolean)
    {   
      
        if(baseGameSymbol){
            return this.baseSymbol[index].getBonus();
        }
        else
        {   //returns bonus symbol
            return this.bonusSymbol[index].getBonus();
        }
    
    }

    public getSymbol(index:number,baseGameSymbol:boolean)
    {   
      
        if(baseGameSymbol){
            return this.baseSymbol[index].getSymbol();
        }
        else
        {   //returns bonus symbol
            return this.bonusSymbol[index].getSymbol();
        }
    
    }

    public getBonusSymbol=():Array<GameSymbol>=>
    {
        return this.bonusSymbol;
    }
    public getNormalSymbol=():Array<GameSymbol>=>
    {
        return this.bonusSymbol;
    }
}




